import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import GetParsedDate from "../shared/GetParsedDate";
import { useMoamadsBetweenDatesContext } from "../shared/context/MoamadsBetweenDatesContext";
import MyJustDate from "../shared/MyJustDate";

const baseURL = process.env.REACT_APP_API_JOBS;

function isValidNumber(x) {
  const numberPattern = /^-?\d+(\.\d+)?$/;
  return numberPattern.test(x);
}

const MoamadRepByDate = ({ pageNumber, setPageNumber, proposalStatus }) => {
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const now = MyJustDate(new Date());
  // State for the selected dates
  const [fromCreatedDate, setFromCreatedDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [toCreatedDate, setToCreatedDate] = useState(
    new Date().toISOString().split("T")[0],
  );

  const { moamadsBetweenDatesRep, updateMoamadsBetweenDatesRep } =
    useMoamadsBetweenDatesContext();
  const axiosPrivate = useAxiosPrivate("application/json");
  const history = useNavigate();

  useEffect(() => {
    document.body.classList.add("accountBodyColor");
    return () => {
      document.body.classList.remove("accountBodyColor");
    };
  }, []);

  const getMoamadRep = async () => {
    let isMounted = true;
    const controller = new AbortController();
    const validPageNumber =
      pageNumber && isValidNumber(pageNumber) ? pageNumber : "1";
    setPageNumber(validPageNumber);

    try {
      const response = await axiosPrivate.get(
        `${baseURL}moamadrepbydates/?fromcreateddate=${fromCreatedDate}&tocreateddate=${toCreatedDate}&page=${validPageNumber}`,
        { signal: controller.signal },
      );

      if (isMounted) {
        updateMoamadsBetweenDatesRep(response.data);
        setNextPage(response.data.next);
        setPrevPage(response.data.previous);
      }
    } catch (err) {
      if (err.response) {
        alert(HandleHttpErrors(err.response.status));
      } else if (err.request) {
        alert(
          "The client never received a response, and the request was never left",
        );
        console.log(err.request);
      } else {
        alert("Anything else");
      }
    }

    return () => {
      isMounted = false;
      controller.abort();
    };
  };

  const handleClickButton = () => {
    if (fromCreatedDate > toCreatedDate) {
      alert("תאריך מיום גדול מתאריך עד!!!!!");
    } else {
      getMoamadRep();
    }
  };
  /*
  const handleTdClick = (
    moamadId,
    userId,
    mekhrazTitle,
    isDisabledDocument
  ) => {
    const url = `/moamadadmin/${moamadId}/${userId}/${encodeURIComponent(
      mekhrazTitle
    )}/${isDisabledDocument}`;
    history(url);
  };*/
  const handleTdClick = (
    moamadId,
    userId,
    mekhrazTitle,
    isDisabledDocument,
  ) => {
    history("/moamadadmin", {
      state: {
        moamad_id: moamadId,
        user_id: userId,
        mekhraz_title: mekhrazTitle,
        is_disabled_doc: isDisabledDocument,
      },
    });
  };

  const handlePageChange = async (pageUrl) => {
    if (!pageUrl) return;

    let isMounted = true;
    const controller = new AbortController();

    try {
      const response = await axiosPrivate.get(pageUrl, {
        signal: controller.signal,
      });

      if (isMounted) {
        updateMoamadsBetweenDatesRep(response.data);
        setPageNumber(new URL(pageUrl).searchParams.get("page"));
        setNextPage(response.data.next);
        setPrevPage(response.data.previous);
      }
    } catch (err) {
      if (err.response) {
        alert(HandleHttpErrors(err.response.status));
      } else if (err.request) {
        alert(
          "The client never received a response, and the request was never left",
        );
        console.log(err.request);
      } else {
        alert("Anything else");
      }
    }

    return () => {
      isMounted = false;
      controller.abort();
    };
  };

  return (
    <div>
      <br />
      <h2 style={{ textAlign: "center", color: "white" }}>
        ההגשות מיום {fromCreatedDate} עד יום {toCreatedDate}
      </h2>

      <form>
        <div style={{ textAlign: "center" }}>
          <Row>
            <Col>
              <label
                style={{
                  color: "black",
                  fontSize: "20px",
                  fontWeight: "bold",
                  marginLeft: "10px",
                }}
              >
                מיום
              </label>
              <input
                type="date"
                name="fromCreatedDate"
                value={fromCreatedDate}
                onChange={(e) => {
                  setFromCreatedDate(e.target.value);
                  setPageNumber(1);
                }}
                className="form-control"
                id="fromCreatedDate"
              />
            </Col>
            <Col>
              <label
                style={{
                  color: "black",
                  fontSize: "20px",
                  fontWeight: "bold",
                  marginLeft: "10px",
                }}
              >
                עד יום
              </label>
              <input
                type="date"
                name="toCreatedDate"
                value={toCreatedDate}
                onChange={(e) => {
                  setToCreatedDate(e.target.value);
                  setPageNumber(1);
                }}
                className="form-control"
                id="toCreatedDate"
              />
            </Col>
          </Row>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleClickButton}
          >
            חפש
          </button>
        </div>
      </form>

      <div style={{ marginTop: "20px", backgroundColor: "rgb(200, 200, 200)" }}>
        <center>
          <h4 className="text-color">{moamadsBetweenDatesRep?.count} הגשות</h4>
        </center>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "black",
            fontWeight: "bold",
          }}
        >
          <table className="centered-table">
            <thead>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  מזהה
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                    textAlign: "center",
                  }}
                >
                  שם מלא
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  מס' מכרז
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  תאור המכרז
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  תאריך יצירה
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  תאריך הגשה
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  תנאי הסף
                </th>
              </tr>
            </thead>
            <tbody>
              {moamadsBetweenDatesRep?.results
                ?.sort((a, b) => b.id - a.id)
                .map((item, index) => {
                  const isDisabled =
                    proposalStatus === "חסויה" &&
                    MyJustDate(new Date(item.mekhraz__hagsha_date)) >= now;
                  const isDisabledDocument =
                    proposalStatus === "מסמכים חסויים" &&
                    MyJustDate(new Date(item.mekhraz__hagsha_date)) >= now;
                  return (
                    <tr style={{ borderBottom: "1px solid #ddd" }} key={index}>
                      <td
                        isDisabled={isDisabled}
                        className="changetextsize-td"
                        style={{
                          textAlign: "center",
                          cursor: isDisabled ? "not-allowed" : "pointer",
                          color: isDisabled ? "gray" : "blue",
                          textDecoration: isDisabled ? "none" : "underline",
                        }}
                        onClick={() => {
                          if (!isDisabled) {
                            handleTdClick(
                              item.id,
                              item.user,
                              item.mekhraz__title,
                              isDisabledDocument,
                            );
                          }
                        }}
                      >
                        {item.id}
                      </td>
                      <td
                        className="padding10-td"
                        style={{ textAlign: "center" }}
                      >
                        {`${item.f_name} ${
                          item.father_name ? item.father_name + " " : ""
                        } ${item.l_name}`}
                      </td>
                      <td
                        className="padding10-td"
                        style={{ textAlign: "center" }}
                      >
                        {item.mekhraz__mkh_num}
                      </td>
                      <td
                        className="padding10-td"
                        style={{ textAlign: "center" }}
                      >
                        {item.mekhraz__title}
                      </td>
                      <td
                        className="padding10-td"
                        style={{ textAlign: "center" }}
                      >
                        <GetParsedDate
                          strDate={item.created_date}
                          withTime={false}
                        />
                      </td>
                      <td
                        className="padding10-td"
                        style={{ textAlign: "center" }}
                      >
                        {item.signature_date ? (
                          <GetParsedDate
                            strDate={item.signature_date}
                            withTime={false}
                          />
                        ) : (
                          "לא הוגשה"
                        )}
                      </td>
                      <td
                        className="padding10-td"
                        style={{ textAlign: "center" }}
                      >
                        {item.saf ? "כן" : "לא"}
                      </td>
                    </tr>
                  );
                })}
              <tr className="centered-row">
                <td>עמוד: {pageNumber != null ? pageNumber : "1"}</td>
                <td>
                  <button
                    id="changePage"
                    className="btn btn-warning"
                    onClick={() =>
                      handlePageChange(moamadsBetweenDatesRep?.previous)
                    }
                    disabled={!moamadsBetweenDatesRep?.previous}
                  >
                    הקודם
                  </button>
                </td>
                <td>
                  {" "}
                  <button
                    id="changePage"
                    className="btn btn-warning"
                    onClick={() =>
                      handlePageChange(moamadsBetweenDatesRep?.next)
                    }
                    disabled={!moamadsBetweenDatesRep?.next}
                  >
                    הבא
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "black",
            fontWeight: "bold",
          }}
        >
          {moamadsBetweenDatesRep?.results?.length === 0 && (
            <p
              style={{
                color: "blue",
                fontWeight: "bold",
                fontSize: "20px",
                textDecoration: "underline",
              }}
            >
              לא קיימות הגשות מתאריך זה
            </p>
          )}
        </div>
      </div>
      <br />
    </div>
  );
};

export default MoamadRepByDate;
